import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, RouteConfigLoadEnd, RouteConfigLoadStart, Router } from '@angular/router';
import { SharedService } from './services/shared-service/shared.service';
import { filter } from 'rxjs';
import { environment } from '../environments/environment.development';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {

  underMaintance: boolean = false;
  isLoading!: boolean;
  
  constructor(
    private router: Router,
    private titleService: Title,
    private sharedService: SharedService,
    private activatedRoute: ActivatedRoute,
  ) { 
    router.events.forEach((event) => { 
      if (event instanceof RouteConfigLoadStart) {
          this.isLoading = true;
      } else if (event instanceof RouteConfigLoadEnd) {
          this.isLoading = false;
      }
    });
  }

  ngOnInit(): void {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
    ).subscribe(() => {
      let rt = this.getChild(this.activatedRoute)
      rt.data.subscribe((data: { title: string; }) => {
        this.sharedService.getData().subscribe((data) => {
          this.titleService.setTitle(data)
        });
      });
    });
    this.underMaintance = environment.isUnderMaintance;
    if (this.underMaintance) {
      this.router.navigate(['under-maintenance']);
    }
  }

  getChild(activatedRoute: ActivatedRoute): any {
    if (activatedRoute.firstChild) {
      return this.getChild(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }
  }
}